// 弹窗广告
import React, { useEffect, useState } from 'react'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useAdStat } from 'Components/ad'
import { setClose, isClosed } from './close'
import { setPast, isPast } from './past_24'
import { MainPopUpAd } from './interface'

export default function PopUpAd({ data }: { data: MainPopUpAd }) {
  const [isShow, setIsShow] = useState(true)

  const past = isPast('popUp', data.id_str)

  const adData = {
    ad_material_id: data.materiel_str,
    ad_target_url: data.web_url,
    log_extra: data.log_extra,
    ad_req_id: JSON.parse(data.log_extra).req_id,
  }
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_main_popup_window',
      show: 'ad_show_main_popup_window',
      click: 'ad_click_main_popup_window',
    },
    data,
    undefined,
    1000
  )

  // 如果已经过期或者未关闭过弹窗，才展示弹窗
  useEffect(() => {
    if (past || !isClosed('popUp', data.id_str)) {
      setClose('popUp', data.id_str)
      setPast('popUp', data.id_str)
      setIsShow(!isClosed('popUp', data.id_str) || past)
      return
    }
    setIsShow(false)
  }, [data.id_str])

  if (!data || !isShow) return null

  // 点击最小化时动效
  const handleMin = (e: any) => {
    e.stopPropagation()
    sendTeaCommEvent('click_main_popup_window_shrink', {
      ...adData,
      shrink_type: 'fold',
    })

    const bg = document.getElementById('pop-bg')
    const car = document.getElementById('pop-car')
    const label = document.getElementById('pop-label')
    const button = document.getElementById('pop-button')
    const minmize = document.getElementById('pop-minmize')
    button && button.classList.add('show')
    bg && bg.classList.add('fade-out')
    car && car.classList.add('lessen')
    label && label.classList.add('fade-out')
    minmize && minmize.classList.add('fade-out')
    button && button.classList.add('fade-in')

    setTimeout(() => {
      bg && bg.classList.add('hide')
      label && label.classList.add('hide')
      minmize && minmize.classList.add('hide')
      car && car.classList.add('small-car')
    }, 700)
  }

  // 点击关闭按钮
  const handleClose = (e: any) => {
    e.stopPropagation()
    setIsShow(false)
    setClose('popUp', data.id_str)
    sendTeaCommEvent('click_main_popup_window_close', adData)
  }

  // 点击广告
  const handleClickAd = () => {
    handleClick()
    window.open(data.web_url, '_blank')
  }

  return (
    <div className="wrap" ref={ref} onClick={() => handleClickAd()}>
      <div className="bg fade-in" id="pop-bg" />
      <div className="car car-in" id="pop-car" />
      <div className="min-wrap fade-in">
        <img
          src={require('static/pop-min.png')}
          className="min"
          onClick={e => handleMin(e)}
          id="pop-minmize"
        />
      </div>
      <span id="pop-label" className="label fade-in">
        {data.label}
      </span>
      <div className="button hide" id="pop-button">
        <span>{data.button}</span>
        <img
          className="close"
          src={require('static/pop-close.png')}
          onClick={e => handleClose(e)}
        />
      </div>
      <style jsx>
        {`
          .wrap {
            position: fixed;
            bottom: 38px;
            right: 0;
            z-index: 999;
          }
          .bg {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 300px;
            height: 200px;
            background: url(${data.background_image?.url}) no-repeat center /
              cover;
          }
          .car {
            position: absolute;
            bottom: 38px;
            right: 0;
            width: 184px;
            height: 85px;
            background: url(${data.car_icon?.url}) no-repeat center / cover;
          }
          .min-wrap {
            position: absolute;
            right: 0;
            top: -200px;
            width: 26px;
            height: 26px;
          }
          .min {
            width: 18px;
            height: 18px;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          .label {
            position: absolute;
            right: 8px;
            bottom: 8px;
            width: 32px;
            padding: 0 3px;
            line-height: 16px;
            text-align: center;
            font-size: 10px;
            color: rgba(255, 255, 255, 0.8);
            background: rgba(0, 0, 0, 0.3);
            border-radius: 2px;
          }
          .small-car {
            width: 104px;
            height: 48px;
            right: -33px;
            background: url(${data.car_icon?.url}) no-repeat center / cover;
          }
          .button {
            width: 55px;
            height: 20px;
            background: url(${require('static/pop-btn.png')}) no-repeat center /
              cover;
            text-align: center;
            line-height: 1.2;
            position: absolute;
            right: 0;
            bottom: 18px;
          }
          .button span {
            color: #de2b2b;
            font-size: 12px;
            font-weight: 600;
            display: inline-block;
            transform: scale(0.83);
          }
          .close {
            width: 18px;
            height: 30px;
            position: absolute;
            bottom: -30px;
            right: 18px;
          }

          .fade-in {
            animation: fadeIn 1.4s ease;
          }
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          .car-in {
            animation: carIn 0.7s ease;
          }
          @keyframes carIn {
            from {
              right: -200px;
            }
            to {
              right: 0;
            }
          }

          .fade-out {
            animation: fadeOut 0.7s ease;
          }
          @keyframes fadeOut {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0;
              display: none;
            }
          }

          .lessen {
            animation: lessen 0.7s ease;
          }
          @keyframes lessen {
            0% {
              width: 184px;
              height: 85px;
            }
            100% {
              width: 104px;
              height: 48px;
              right: -33px;
            }
          }

          .hide {
            display: none;
          }
          .show {
            display: block;
          }
        `}
      </style>
    </div>
  )
}
